/**
 * Supabase's opaque API keys authenticate through `apikey`, never Bearer.
 *
 * Keep real user access tokens intact. This wrapper only removes the SDK's
 * fallback Authorization value when it is exactly the configured API key.
 */
export function createOpaqueKeySafeFetch(apiKey: string, fetchImpl: typeof fetch): typeof fetch {
  return (input, init) => {
    const headers = new Headers(input instanceof Request ? input.headers : undefined)
    new Headers(init?.headers).forEach((value, name) => headers.set(name, value))

    if (headers.get("authorization") === `Bearer ${apiKey}`) {
      headers.delete("authorization")
    }

    return fetchImpl(input, { ...init, headers })
  }
}
